import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgSalaryHover(props: RootSvgProps) {
  return (
    <RootSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_168_4505)">
        <path
          d="M7 14C7.28333 14 7.52083 13.9042 7.7125 13.7125C7.90417 13.5208 8 13.2833 8 13C8 12.7167 7.90417 12.4792 7.7125 12.2875C7.52083 12.0958 7.28333 12 7 12C6.71667 12 6.47917 12.0958 6.2875 12.2875C6.09583 12.4792 6 12.7167 6 13C6 13.2833 6.09583 13.5208 6.2875 13.7125C6.47917 13.9042 6.71667 14 7 14ZM7 10C7.28333 10 7.52083 9.90417 7.7125 9.7125C7.90417 9.52083 8 9.28333 8 9C8 8.71667 7.90417 8.47917 7.7125 8.2875C7.52083 8.09583 7.28333 8 7 8C6.71667 8 6.47917 8.09583 6.2875 8.2875C6.09583 8.47917 6 8.71667 6 9C6 9.28333 6.09583 9.52083 6.2875 9.7125C6.47917 9.90417 6.71667 10 7 10ZM9 14H18V12H9V14ZM9 10H18V8H9V10ZM8 21V19H4C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H16V21H8Z"
          fill="#2D2D2D"
        />
      </g>
      <defs>
        <clipPath id="clip0_168_4505">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
